import React, { useContext } from "react";
import { TranslationContext } from "../../Providers/TranslationProvider";

const OptionCard = props => {
    const { trans } = useContext(TranslationContext);


    return (
        <div className="w-1/2 md:w-1/4 lg:w-1/5 px-2 pb-6 flex flex-col">
            <div
                onClick={() =>
                    props.option.active &&
                    props.selectOption(props.type, props.option.value)
                }

                className={`transition duration-200 ease-in-out border relative flex-grow bg-white border-solid rounded py-2 px-4 cursor-pointer border hover:border-yellow-100 ${props
                    .option.selected && "border-b-4 border-yellow-100"} `}
            >
                {props.option.popular && (
                    <div
                        style={{ right: "8px", top: "8px", fontSize: "11px" }}
                        className="px-2 py-1 absolute bg-red-500 text-white rounded"
                    >
                        <span style={{ fontSize: "11px" }} className="font-bold ">
                            populair
                        </span>
                    </div>
                )}

                {!props.option.active && (
                    <div className="black-overlay-2 absolute inset-0 rounded flex justify-center items-center">
                        <span className="text-center text-sm px-2">
                            Combinatie niet mogelijk
                        </span>
                    </div>
                )}
                <img
                    className="w-24 mx-auto mb-2"
                    src={`/images/product-options/${props.type}/${
                        props.option.value
                    }.png`}
                    alt="Product optie"
                />
                <h6
                    className={` text-center text-sm ${props.option.selected &&
                        "font-bold"}`}
                >
                    {props.option.name}
                </h6>
                <span className="block text-xs text-gray-600 text-center mb-2">
                    {props.option.description}
                </span>
            </div>
            {props.option.extra_info &&
                JSON.parse(props.option.extra_info).title && (
                    <div className="pt-2 flex justify-center">
                        <button
                            onClick={e =>
                                props.onOpenExtraInfoModal(
                                    e,
                                    props.option.extra_info,
                                    props.type,
                                    props.option.value
                                )
                            }
                            className="text-gray-700 hover:text-blue-400"
                        >
                            <i className="fas fa-eye mr-1" /> bekijk
                        </button>
                    </div>
                )}
        </div>
    );
};

export default OptionCard;

// function detectIE() {
//     const ua = window.navigator.userAgent;

//     const msie = ua.indexOf("MSIE ");
//     if (msie > 0) {
//         // IE 10 or older => return version number
//         return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
//     }

//     const trident = ua.indexOf("Trident/");
//     if (trident > 0) {
//         // IE 11 => return version number
//         const rv = ua.indexOf("rv:");
//         return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
//     }

//     const edge = ua.indexOf("Edge/");
//     if (edge > 0) {
//         // Edge (IE 12+) => return version number
//         return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
//     }

//     // other browser
//     return false;
// }
